import { BaseService } from "core/services";
import { ConfirmingReportItemValidationRouteService } from "application/confirming-report/services";

class ConfirmingReportItemValidationService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ConfirmingReportItemValidationRouteService());
	}

	updateValidations(resource) {
		const url = this.routeService.updateValidations(resource);

		return this.apiClient.put(url, resource);
	}
}

export default ConfirmingReportItemValidationService;